import SEO from "@/components/SEO";
import { PORTFOLIO } from "@/lib/content";
import { ArrowUpRight } from "lucide-react";

export default function Portfolio() {
  return (
    <>
      <SEO title="Portfolio — Tech Alpha SSL" description="Selected engagements — fintech, healthcare, e-commerce, and SaaS." canonical="https://techalphassl.com/portfolio" />
      <section className="pt-20 pb-10">
        <div className="container-page max-w-4xl">
          <span className="eyebrow">Portfolio</span>
          <h1 className="mt-4 text-4xl md:text-6xl font-semibold tracking-tighter">Work that speaks for itself.</h1>
          <p className="mt-4 text-lg text-muted-foreground">A small selection of engagements. Names anonymized where required by NDA.</p>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-page grid gap-6 md:grid-cols-2">
          {PORTFOLIO.map((p, i) => (
            <a key={i} href="#" onClick={(e) => e.preventDefault()} data-testid={`portfolio-item-${i}`} className="group card-elevated overflow-hidden">
              <div className="relative h-56 overflow-hidden">
                <img src={p.image} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <span className="absolute top-3 left-3 inline-flex items-center rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-medium text-[#0B1220]">{p.tag}</span>
              </div>
              <div className="p-6 flex items-center justify-between gap-4">
                <div>
                  <h3 className="text-lg font-semibold tracking-tight">{p.title}</h3>
                  <p className="mt-1 text-sm text-muted-foreground">{p.detail}</p>
                </div>
                <ArrowUpRight className="h-5 w-5 text-muted-foreground group-hover:text-[#1565FF] transition-colors" />
              </div>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}
